<template>
  <div class="main-container">
    <div>
      <tl-header type="h1">
        <div>FBP Components Grouping</div>
      </tl-header>
    </div>
    <div class="permission-alert-msg" v-if="errmsg">
      selcted component is alredy selected Please select different One
    </div>

    <toast-message
      :message="errmsg"
      :isToastEnable="toast"
      type="error"
      @close="(val) => (toast = val)"
    />

    <pop-up-message
      v-if="showSuccessMsg"
      :message="`FBP Eligibility Configure has been successfully created`"
      btnText="Back"
      @back="backfrompopup()"
    />
    <div class="mt-50">
      <data-table
        :columns="fbpCtcSlabsColumnNames"
        :tableData="fbpCtcSlabsData"
        class="custom-data-table-class"
        :checkbox="false"
        :withForm="false"
        :showinrow="false"
        :showedit="true"
      >
        <template v-slot:rowcontent="slotprops">
          <p v-if="slotprops.value.column.key == 'name'">
            {{ slotprops.value.record[slotprops.value.column.key] }}
          </p>
          <tl-select
            v-if="slotprops.value.column.key == 'selectComponent'"
            class="custom-width-slotprop"
            name="calculation_type"
            labelText="name"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="
              (val) => {
                selectedComponent(
                  val,
                  slotprops.value,
                  'selectComponent'
                );
              }
            "
            :options="fbpCtcSlabsData"
          />
          <txt
            class="custom-width"
            v-if="slotprops.value.column.key == 'value'"
            :autofocus="false"
            maxlength=""
            name="value"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="
              (val) => {
                saveValues(val, slotprops.value.record, 'value');
              }
            "
          />
          <txt
            class="custom-width"
            v-if="slotprops.value.column.key == 'OptionOne'"
            :autofocus="false"
            maxlength="9"
            name="value"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="
              (val) => {
                saveValues(val, slotprops.value.record, 'value');
              }
            "
          />
          <txt
            class="custom-width"
            v-if="slotprops.value.column.key == 'OptionTwo'"
            :autofocus="false"
            maxlength="9"
            name="value"
            v-model="slotprops.value.record[slotprops.value.column.key]"
            @change="
              (val) => {
                saveValues(val, slotprops.value.record, 'value');
              }
            "
          />
        </template>
      </data-table>
    </div>
    <bottom-action-container>
            <template slot="end">
              <btn-grp>
                <btn
                  text="cancel"
                  type="secondary"
                  @click="$router(-1)"
                />
                <btn :disabled="hideSaveButton" text="Save" type="primary" @click="$emit('stepNum', 3)" />
              </btn-grp>
            </template>
          </bottom-action-container>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
  data() {
    return {
        errmsg:false,
        hideSaveButton:false,
      fbpCtcSlabsData: [],
      fbpCtcSlabsColumnNames: [
        {
          label: "FBP Component",
          key: "name",
        },
        {
          label: "Select Component",
          key: "selectComponent",
        },
        {
          label: "Title",
          key: "value",
        },
        {
          label: "Option 1",
          key: "OptionOne",
        },
        {
          label: "Option 2",
          key: "OptionTwo",
        },
      ],
      fbpCtcCalcArray: ["fuel100CC", "fuel200cc", "fuel1000cc", "fuel1200cc "],
    };
  },
  mounted() {
    this.fbpCtcSlabsData = this.salaryComponentsData[this.leId];
  },
  computed: {
    leId() {
      if (this.$route.params.entity_index) {
        return this.getLegalEntityId(this.$route.params.entity_index);
      } else return this.getLegalEntityId(0);
    },
    ...mapGetters({
      getLegalEntityId: "onboard/legal_entities/legal_entity_ID",
    }),
    ...mapState({
      salaryComponentsData: (state) =>
        state.onboard.settings.salary_component.entityWiseData,
    }),
  },
  methods: {
    selectedComponent(val,record,type){
        if(this.fbpCtcSlabsData[record.index].id == val.id){
            this.errmsg =true
            this.hideSaveButton = true
        }
        else{
            this.errmsg =false
            this.hideSaveButton = false
            console.log("both or not equal",val.name)
        }
    
    }
  },
};
</script>
<style scoped>
.custom-width {
  width: 18rem;
}
</style>
